module.exports = __webpack_public_path__ + "static/media/027-wind-sign.edf700e9.svg";